/** Workspace rollout modes via `REACT_APP_WORKSPACE_ENABLED`. */
export type WorkspaceFeatureFlagMode = "true" | "false" | "internal";

function readWorkspaceFlagMode(): WorkspaceFeatureFlagMode {
  const raw = (process.env.REACT_APP_WORKSPACE_ENABLED ?? "true").trim().toLowerCase();
  if (raw === "false") return "false";
  if (raw === "internal") return "internal";
  return "true";
}

/** Whether Workspace nav and routes are available for this user. */
export function isWorkspaceEnabledForUser(isAdmin = false): boolean {
  const mode = readWorkspaceFlagMode();
  if (mode === "true") return true;
  if (mode === "false") return false;
  return isAdmin;
}

/**
 * Legacy helper — returns true when workspace is enabled in `true` or `internal` mode.
 * Prefer `isWorkspaceEnabledForUser(isAdmin)` in UI that knows the current user.
 */
export function isWorkspaceEnabled(): boolean {
  return readWorkspaceFlagMode() !== "false";
}

/**
 * Phase 3 nav cutover: hide Strategies / Reports / Simulator list pages when Workspace
 * is the primary surface. Default on; set `REACT_APP_WORKSPACE_NAV_CUTOVER=false` to restore.
 */
export function isWorkspaceNavCutoverEnabled(): boolean {
  const raw = (process.env.REACT_APP_WORKSPACE_NAV_CUTOVER ?? "true").trim().toLowerCase();
  return raw !== "false";
}

export function shouldHideLegacyPipelineNav(isAdmin = false): boolean {
  return isWorkspaceNavCutoverEnabled() && isWorkspaceEnabledForUser(isAdmin);
}
